import React from "react";
import * as palette from "@govlaunch/palette";
import * as Types from "~/types/types";
import { IStripeChargeFieldsFragment } from "~/lib/queries/fragments/__generated__/StripeChargeFields.generated";
import IntlDateTime from "~/src/shared/components/IntlDateTime";
import { FormattedMessage } from "react-intl";

interface ICurrentBullingOverdueSubscriptionProps {
  subscription: { __typename: "OverdueSubscription" } & Pick<
    Types.IOverdueSubscription,
    "_id" | "willCancelAt" | "nextPaymentAttempt" | "nextPaymentAmount"
  > & { lastCharge: Types.Maybe<{ __typename: "Charge" } & IStripeChargeFieldsFragment> };
}

export default function CurrentBullingOverdueSubscription({ subscription }: ICurrentBullingOverdueSubscriptionProps) {
  return (
    <>
      <div
        css={{
          fontSize: 16,
          fontWeight: 600,
          color: "#949195",
        }}
      >
        <FormattedMessage defaultMessage="Next Payment Due" id="RANMXE" />
      </div>

      <div
        css={{
          display: "grid",
          gridRowGap: 8,
        }}
      >
        <strong
          css={{
            fontSize: 16,
            fontWeight: 600,
            color: palette.text,
          }}
        >
          {subscription.nextPaymentAttempt ? (
            <IntlDateTime value={subscription.nextPaymentAttempt} />
          ) : (
            <FormattedMessage defaultMessage="Not available" id="cPhKTw" />
          )}
        </strong>

        {subscription.nextPaymentAmount !== null && (
          <div>
            <span
              css={{
                fontSize: 13,
                color: "#ff7171",
              }}
            >
              <FormattedMessage
                defaultMessage="Your payment of {payment} is overdue. Please update your payment information below to avoid an account downgrade."
                id="/i/x90"
                values={{
                  payment: (subscription.nextPaymentAmount / 100).toFixed(2),
                }}
              />
            </span>
          </div>
        )}
      </div>
    </>
  );
}
